import * as types from "../dashboardActionTypes";

const initialState = {
    logSizeDay: [],
    isLogLimitReached: false,
    logSpaceThresholdPerDayGb: 100,
    isSuccessful: true,
    errorMessage: ''
};

export default function logsPerDayReducer(state = initialState, action) {
    switch(action.type) {
        case types.LOAD_LOGS_PER_DAY_SUCCESS:
            return action.logsPerDay;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/logsPerDayReducer.js